import React from "react";
import { toast } from "react-toastify";

interface Props {
  closeToast: () => void;
  data: {
    message: string;
  };
  isPaused: boolean;
  toastProps: any;
}

const Toast = (props: Props) => {
  return <div>
    {props.data.message}
  </div>
}

export const toastError = (message: string) => {
  toast.error(Toast, {
    theme: "light",
    data: {
      message
    }
  });
}

export const toastSuccess = (message: string) => {
  toast.success(Toast, {
    theme: "light",
    data: {
      message
    }
  });
}